import React, { useState, useEffect } from "react";
import Layout from "layout/layout";
import { FloatingLabel, Form } from "react-bootstrap";
import emptyFile from "../../assets/images/emptydata.gif";
import { subscriptionConfig } from "../../api/config/subscriptionConfig";

const Subscription: React.FC = () => {
  const [selectedPackage, setSelectedPackage] = useState("");
  const [menu, setMenu] = useState("");
  const [thirdValue, setThirdValue] = useState("");
  const [searchResult, setSearchResult] = useState(false);

  const currentConfig = subscriptionConfig[selectedPackage];

  const currentMenuConfig = currentConfig?.thirdDropdowns?.[menu];
  const SelectedComponent = currentMenuConfig?.options.find(
    (opt) => opt.name === thirdValue
  )?.component;

  const handleSearch = () => {
    
    setSearchResult(true);
  };

  useEffect(() => {
    // reset dependent dropdowns when package changes
    setMenu("");
    setThirdValue("");
    setSearchResult(false);
  }, [selectedPackage]);

  return (
    <Layout>
      <div className="mt-4" style={{overflowY: "auto", height: "74vh", overflowX: "hidden",}}>
        <Form>
          <div className="row">
            {/* PACKAGES DROPDOWN */}
            <div className="col-md" style={{ width: "32%" }}>
              <FloatingLabel
                controlId="floatingPackage"
                label="Select Package"
                className="float-input"
              >
                <Form.Select
                  value={selectedPackage}
                  onChange={(e) => setSelectedPackage(e.target.value)}
                  className="border-0 w-100"
                >
                  <option value="">Choose Package</option>
                  {Object.keys(subscriptionConfig).map((pkg) => (
                    <option key={pkg} value={pkg}>
                      {pkg}
                    </option>
                  ))}
                </Form.Select>
              </FloatingLabel>
            </div>

            {/* MENUS DROPDOWN (always visible, but empty until package is picked) */}
            <div className="col-md" style={{ width: "32%" }}>
              <FloatingLabel
                controlId="floatingMenu"
                label="Select Menu"
                className="float-input"
              >
                <Form.Select
                  value={menu}
                  onChange={(e) => setMenu(e.target.value)}
                  className="border-0 w-100"
                  disabled={!selectedPackage}
                >
                  <option value="">Choose Menu</option>
                  {currentConfig?.menus.map((menuItem) => (
                    <option key={menuItem} value={menuItem}>
                      {menuItem}
                    </option>
                  ))}
                </Form.Select>
              </FloatingLabel>
            </div>

            {/* THIRD DROPDOWN (always visible, but depends on package) */}
            <div className="col-md" style={{ width: "32%" }}>
              <FloatingLabel
                controlId="floatingThird"
                label={currentMenuConfig?.label || "options"}
                className="float-input"
              >
                <Form.Select
                  value={thirdValue}
                  onChange={(e) => setThirdValue(e.target.value)}
                  className="border-0 w-100"
                  disabled={!menu} // now depends on menu
                >
                  <option value="">
                    {menu
                      ? `Choose ${currentMenuConfig?.label}`
                      : "Select a menu first"}
                  </option>
                  {currentMenuConfig?.options.map((opt) => (
                    <option key={opt.name} value={opt.name}>
                      {opt.name}
                    </option>
                  ))}
                </Form.Select>
              </FloatingLabel>
            </div>

            {/* BUTTON */}
            <div className="col-md" style={{ width: "4%" }}>
              <button
                type="button"
                onClick={handleSearch}
                className="btn-primary"
                disabled={!thirdValue}
              >
                View
              </button>
            </div>
          </div>
        </Form>

        {/* EMPTY STATE */}
        {!searchResult && (
          <div className="row mt-5 pt-5">
            <div className="col-lg-4 text-center m-auto">
              <img src={emptyFile} width="50%" alt="empty" />
              <p>Subscription summary would appear here</p>
            </div>
          </div>
        )}

        {/* RENDER SELECTED COMPONENT (based on third dropdown) */}
        {searchResult && SelectedComponent && (
          <SelectedComponent
            summaryData={{
              selectedPackage,
              menu,
              thirdValue,
            }}
            refresh={searchResult}
          />
        )}
      </div>
    </Layout>
  );
};

export default Subscription;
